import React from 'react'
import { Link } from 'react-router-dom';
function Nav() {
    return (
        <div>
            <nav className="nav-main mainmenu-nav d-none d-xl-block">
                <ul className="mainmenu">
                    <li>
                        <Link className="nav-item" to={'/'}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-item" to={'/about-us'}>
                            About Us
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-item" to={'/services'}>
                            Services
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-item" to={'/contactus'}>
                            Contact
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Nav